import { render, staticRenderFns } from "./NavBread.vue?vue&type=template&id=bad50b9e&scoped=true"
import script from "./NavBread.vue?vue&type=script&lang=ts"
export * from "./NavBread.vue?vue&type=script&lang=ts"
import style0 from "./NavBread.vue?vue&type=style&index=0&id=bad50b9e&prod&lang=scss&scoped=true"
import style1 from "./NavBread.vue?vue&type=style&index=1&id=bad50b9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad50b9e",
  null
  
)

export default component.exports